import "./App.css";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/home";
import Login from "./pages/login";
import NotFound from "./pages/not-found";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

function App() {
  const navigate = useNavigate();
  useEffect(() => {
    const kraken = sessionStorage.getItem("krakenT");

    if (!kraken) {
      navigate("/login");
    }
  }, [navigate]);
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
